class PartDiagram extends HTMLElement {
  constructor() {
    super();
    this.section_id = this.dataset.sectionId;
    this.diagram_handle = this.dataset.diagramHandle;
    this.parts_count= this.dataset.partsCount;

    this.desktopViewport = '';

    this.elements = {
      partDiagramWrapper: this.querySelector(".part-diagram-wrapper"),
      partsList: this.querySelector(".parts-list"),
      fixedTableContainer: this.querySelector(".fixed-table-container"),
      normalTableContainer: this.querySelector(".normal-table-container")
    }

    this.scrollToBeginningOfDiagramNumber = this.scrollToBeginningOfDiagramNumber.bind(this)
    this.elements.normalTableContainer.addEventListener('scroll', this.handleTableScroll.bind(this, this.elements.normalTableContainer, this.elements.fixedTableContainer));

    let resizeObserver = new ResizeObserver((entries) => this.resizeThumbnailScroll());
    resizeObserver.observe(this.elements.partDiagramWrapper);

    this.initializeDataRetrieval();
    this.stickyTableHeader();
  }

  async initializeDataRetrieval() {
    let requestCount = Math.ceil(parseInt(this.parts_count) / 20);
    let requestArray = [];

    for (let request = 0; request < requestCount; request++) {
      requestArray.push({ index: request, parts_offset: request * 20 })
    }

    const promises = requestArray.map(request => this.getPartDiagramData(this.diagram_handle, request.parts_offset));
    const parts = await Promise.all(promises).catch(error => console.log(`Error getting all parts - ${error}`));

    if (parts) {
      let partsHtml = parts.join("");
      let partsBody = this.querySelector('tbody');
      if (partsHtml !== "") {
        partsBody.innerHTML = partsHtml;
      }
    }
  }

  getPartDiagramData = (diagram_handle, parts_offset) => fetch(`/pages/sale?view=part-diagram-endpoint${`&diagram-handle=${diagram_handle}`}${`&parts-offset=${parts_offset}`}&page=${Date.now()}`)
    .then((r) => r.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, 'text/html');
      let items_source = html.querySelector('tbody');
      if (items_source) {
        return items_source.innerHTML
      }
    }).catch(() => {});

  scrollToBeginningOfDiagramNumber(e) {
    let diagramNumber = e.currentTarget.parentElement.dataset.diagramNumber;
    let scrollAmount = 0;
    let parts = Array.from(this.elements.partsList.querySelectorAll('tr'));
    let foundPartIndex = parts.findIndex(part => part.dataset.diagramNumber === diagramNumber);

    if (foundPartIndex !== -1) {
      scrollAmount -= this.elements.normalTableContainer.querySelector('thead').getBoundingClientRect().height;
      scrollAmount += parts[foundPartIndex].getBoundingClientRect().top;
      scrollAmount += window.scrollY;
  
      window.scrollTo({
        top: scrollAmount + 1,
        behavior: 'smooth',
      });
    }
  }

  stickyTableHeader() {
    let fixedTableContainer= this.elements.fixedTableContainer;
    let normalTableContainer= this.elements.normalTableContainer;
    let handleScroll = this.handleTableScroll;

    let resizeObserver = new ResizeObserver((entries) => this.resizeStickyTableHeader(normalTableContainer, fixedTableContainer));
    resizeObserver.observe(normalTableContainer);

      let observerNormal = new IntersectionObserver(
        function (entries) {  
          const { isIntersecting, target, boundingClientRect, intersectionRect, intersectionRatio } = entries[0];
            if (!isIntersecting && intersectionRatio === 0) {
              if (boundingClientRect.y < 0) {
                fixedTableContainer.querySelector('table').classList.add('visible');
                handleScroll(normalTableContainer, fixedTableContainer);
              }
    
            } else {
              fixedTableContainer.querySelector('table').classList.remove('visible');
            }
        },
        {
          threshold: [0]        
        }
      );
      observerNormal.observe(normalTableContainer.querySelector('thead'));

      let observerFixed = new IntersectionObserver(
        function (entries) {
  
          const { isIntersecting, target, boundingClientRect, intersectionRect, intersectionRatio } = entries[0];
            if (!isIntersecting && intersectionRatio === 0) {
              fixedTableContainer.querySelector('table').classList.remove('visible');    
            } else {
              if (boundingClientRect.y > 60) return;
              fixedTableContainer.querySelector('table').classList.add('visible');
              handleScroll(normalTableContainer, fixedTableContainer);
            }
        },
        {
          threshold: [0]        
        }
      );
      observerFixed.observe(normalTableContainer);
    

  }

  resizeStickyTableHeader(normalTableContainer, fixedTableContainer) {
    let normalTableContainerDimensions = normalTableContainer.getBoundingClientRect();
    let normalTableDimensions = normalTableContainer.querySelector('table').getBoundingClientRect();
    let normalTableHeaders = Array.from(normalTableContainer.querySelectorAll('th'));
    let fixedTableHeaders = Array.from(fixedTableContainer.querySelectorAll('th'));

    fixedTableContainer.style = `width:${normalTableContainerDimensions.width}px`;
    fixedTableContainer.querySelector('table').style = `width:${normalTableDimensions.width}px`;

    for (const [index, element] of normalTableHeaders.entries()) {
      let dimensions = element.getBoundingClientRect();
      fixedTableHeaders[index].style = `width:${dimensions.width}px`;
    }
  }

  handleTableScroll(normalTableContainer, fixedTableContainer) {
    let scrollLeft = normalTableContainer.scrollLeft;
    fixedTableContainer.scrollTo({ left: scrollLeft })
  }

  resizeThumbnailScroll() {
    let desktopSize = window.matchMedia("(min-width: 1200px)");
    if(desktopSize.matches && this.desktopViewport !== true) {
      this.desktopViewport = true;
      this.elements.partDiagramWrapper.querySelectorAll('[id^="GalleryThumbnails"] [data-diagram-number]').forEach((diagramThumbnail) => {
        diagramThumbnail.querySelector('button').addEventListener('click', this.scrollToBeginningOfDiagramNumber);
      });
    }
    if(!desktopSize.matches && this.desktopViewport === true) {
      this.desktopViewport = false;
      this.elements.partDiagramWrapper.querySelectorAll('[id^="GalleryThumbnails"] [data-diagram-number]').forEach((diagramThumbnail) => {
        diagramThumbnail.querySelector('button').removeEventListener('click', this.scrollToBeginningOfDiagramNumber);
      });
    }
  }
}

let backTopButton = document.getElementById('backTop');

window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  if (document.body.scrollTop > 2000 || document.documentElement.scrollTop > 2000) {
    backTopButton.style.display = 'flex';
  } else {
    backTopButton.style.display = 'none';
  }
}

function backTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}


customElements.define('part-diagram', PartDiagram);
